import React from "react";
import { Modal, Button } from "antd";

const SuccessModal = ({ visible, onOk }) => {
  return (
    <Modal
      title="Success"
      open={visible}
      onOk={onOk}
      onCancel={onOk} // เพิ่มบรรทัดนี้: เพื่อให้กด X หรือกดพื้นหลัง ก็จะไปเรียกฟังก์ชันเคลียร์ค่าเหมือนกด OK
      footer={[
        <Button key="ok" type="primary" onClick={onOk}>
          OK
        </Button>
      ]}
    >
      <p>Input created successfully</p>
    </Modal>
  );
};

export default SuccessModal; 